export default __webpack_public_path__ + "locales/bg/Files.json?hash=bce87beb0c03525291a6437a276a6775";